import { Col, ControlLabel, FormGroup, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import React from 'react';
import AuthorizedAction from '../../AuthorizedAction.js';
import GroupsBulkSelect from '../../GroupsBulkSelect.jsx';
import ImpactedGroups from '../../group-form-field/SelectedGroups.jsx';
import EmployeesField from '../../EmployeesField.jsx';
import ExternalEntitiesSelect from './ChangeImpactFormFields/ExternalEntitiesSelect.jsx';
import CustomRadio from '../../CustomRadio.jsx';
import FieldGroup from '../../FieldGroup.jsx';

const uploadMethodOptions = [
  { label: 'Add Manually', value: 'manually' },
  { label: 'Bulk CSV Upload', value: 'csv' },
];

const replaceOptions = [
  {
    label: 'Add new impacted groups and people to an existing structure',
    value: 'add',
  },
  { label: 'Replace existing structure', value: 'replace' },
];

const WhoIsImpactedSelect = ({
  editing,
  externalEntities,
  ungroupedEmployees,
  groups,
  onUpdateExternal,
  onShowManageParticipantsModal,
  ungroupedSearchParams,
  onSelectUngroupedEmployee,
  onSelectAllGroupEmployees,
  onSelectGroup,
  onShowManageGroupModal,
  onShowGroupModal,
  uploadMethod,
  replaceMethod,
  setUploadMethod,
  setReplaceMethod,
  currentCSVDownloadButton,
  exampleCSVDownloadButton,
}) => {
  return (
    <React.Fragment>
      <p className="text-muted m-b-24">
        Upload a CSV or add impacted Group(s) or People
      </p>
      <div className="m-b-18">
        <CustomRadio
          name="impactedUploadMethod"
          checkedValue={uploadMethod}
          options={uploadMethodOptions}
          action={setUploadMethod}
        />
      </div>
      {uploadMethod === 'csv' ? (
        <React.Fragment>
          {externalEntities.length ||
          ungroupedEmployees.length ||
          Object.keys(groups).length ? (
            <Row className="m-b-48">
              <Col xs={12}>
                <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
                  <h3>Existing Structure</h3>
                </div>
              </Col>
              <Col xs={12}>
                <div className="m-b-18">
                  <CustomRadio
                    name="stakeholdersReplaceMethod"
                    checkedValue={replaceMethod}
                    options={replaceOptions}
                    action={setReplaceMethod}
                  />
                </div>
              </Col>
              <Col xs={12}>{editing ? currentCSVDownloadButton : null}</Col>
            </Row>
          ) : null}
          <Row>
            <Col xs={12}>
              <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
                <h3>Bulk CSV Upload</h3>
              </div>
            </Col>
            <Col xs={12}>
              <div className="m-b-18">{exampleCSVDownloadButton}</div>
            </Col>
            <Col xs={12}>
              <Field
                id="stakeholdersFormCsvFile"
                name="groups_structure_csv"
                type="file"
                component={FieldGroup}
                accept=".csv"
              />
            </Col>
          </Row>
        </React.Fragment>
      ) : null}

      {uploadMethod === 'manually' ? (
        <React.Fragment>
          <FormGroup>
            <ControlLabel className="flex flex-justify">
              <div>
                Select or Add Impacted Group
                <strong className="bordered bordered-xs text-muted m-l-8">
                  Total:&nbsp;
                  <span className="text-info-brand count">
                    {Object.keys(groups).length}
                  </span>
                </strong>
              </div>
              <AuthorizedAction action="create" subject="group">
                <button
                  type="button"
                  className="btn-clear btn-link"
                  onClick={onShowGroupModal}
                >
                  + Add Group
                </button>
              </AuthorizedAction>
            </ControlLabel>
            <GroupsBulkSelect
              selected={groups}
              handleSelect={onSelectGroup}
              onShowGroupModal={onShowGroupModal}
              showArchived={editing}
              customClass="m-0"
            />
          </FormGroup>

          <ImpactedGroups
            selected={groups}
            handleSelect={onSelectGroup}
            onSelectAllGroupEmployees={onSelectAllGroupEmployees}
            onShowManageModal={onShowManageGroupModal}
          />
          <div className="m-b-24">
            <Field
              id="people"
              name="people"
              selected={ungroupedEmployees}
              handleSelect={onSelectUngroupedEmployee}
              additionalSearchParams={ungroupedSearchParams}
              onShowManageModal={onShowManageParticipantsModal}
              title="Select or Add Impacted People"
              component={EmployeesField}
            />
          </div>

          <ExternalEntitiesSelect
            entities={externalEntities}
            updateEntities={onUpdateExternal}
          />
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
};

export default WhoIsImpactedSelect;
